<div class="m-auto p-3 w-100">
  <header class="d-flex align-items-center">
    <mat-icon (click)="getBackCaseList()">chevron_left</mat-icon>
    <h1>{{currentEntity?.patientFullName ?? 'Nombre del paciente'}}</h1>
  </header>

  <div class="pt-3 custom-container">
    <div class="container-lg py-4 d-flex flex-column gap-5">
      <div class="row w-100 gy-4">
        <!-- Patient data -->
        <div class="col-12">
          <mat-card class="card-general">
            <mat-card-title>Datos del paciente</mat-card-title>
            <mat-card-content class="d-flex flex-column gap-4">
              <div class="row">
                <div class="col-12 col-sm-6 d-flex flex-wrap">
                  <strong class="col-12 col-sm-3">Paciente: </strong>
                  <p>{{currentEntity?.patientFullName ?? 'Nombre del paciente'}}</p>
                </div>
                <div class="col-12 col-sm-6 d-flex flex-wrap">
                  <strong class="col-12 col-sm-3">Fecha alta: </strong>
                  <p>{{(currentEntity?.createdDate | dynamic: 'dateTime')}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 d-flex flex-wrap">
                  <strong class="col-12 col-sm-3">Edad: </strong>
                  <p>{{(currentEntity?.patientBirthday | dynamic: 'age')}}</p>
                </div>
                <div class="col-12 col-sm-6 d-flex flex-wrap">
                  <strong class="col-12 col-sm-3">Correo: </strong>
                  <p>{{currentEntity?.patientEmail}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 d-flex flex-wrap">
                  <strong class="col-12 col-sm-3">Etapa actual: </strong>
                  <p>#{{currentEntity?.stageCount}}</p>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="d-flex flex-wrap">
                    <strong class="col-12 col-sm-3">Setups realizados: </strong>
                    <p>{{currentEntity?.setupCount}}</p>
                  </div>
                  <div class="mt-2"> 
                    <strong>Alineadores requeridos del setup actual</strong>
                    <div class="d-flex"> 
                      <p class="me-3"><span>Superiores: {{currentEntity?.currentStageSetupUpperAlignersByAliwell || 0}}</span></p>
                      <p><span>Inferiores: {{currentEntity?.currentStageSetupLowerAlignersByAliwell || 0}}</span></p>
                    </div>
                   </div>
                </div>
              </div>
              <div class="row w-100 gy-4">
                <div class="col-12 col-sm-6 d-flex flex-wrap align-items-center">
                  <strong class="col-12 col-sm-3">Estatus: </strong>
                  <p class="p-2 status-text" [ngStyle]="{'background-color': currentEntity?.statusColor, 'color': currentEntity?.statusColor != 'transparent' ? '#fff' : '#333'}">{{currentEntity?.statusDescriptionEcommerce ?? currentEntity?.statusCaseDescription}}</p>
                </div>
                <div class="col-12 col-sm-6 d-flex flex-wrap justify-content-start justify-content-sm-end" *ngIf="currentEntity?.productId == null">
                  <button mat-button class="buttonAddService" *ngIf="!hasPendingPayment" (click)="caseServicesCatalogDialog.show = !caseServicesCatalogDialog.show"> Comprar Producto <mat-icon>add_circle</mat-icon></button>
                </div>
              </div>
              <div class="row" *ngIf="currentEntity?.expirationDate">
                <div class="col-12 col-sm-6 d-flex flex-wrap">
                  <strong class="col-12 col-sm-3">Fecha de expiración del caso: </strong>
                  <p>{{currentEntity?.expirationDate | dynamic: 'dateTime'}}</p>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="d-flex flex-wrap">
                    <strong class="col-12 col-sm-3">Producto actual: </strong>
                    <p>{{productName ?? 'Ninguno'}}</p>
                  </div>
                  <div class="mt-2" *ngIf="showPaymentStatusAlert()">
                    <p class="badge bg-danger text-white text-wrap" style="font-size: 12px !important;">Asignada con pago pendiente</p>
                  </div>
                  <div class="d-flex flex-wrap">
                    <strong class="col-12 col-sm-3">Caso complejo: </strong>
                    <p>{{hasComplexCase==true ? 'Sí' : 'No'}}</p>
                  </div>
                  <div class="mt-3 d-flex gap-3 flex-wrap">
                    <button mat-button class="p-2 button info-button" [disabled]="getIsCaseExpired" (click)="onOpenAddServices()"> Agregar Servicios <mat-icon>add_circle</mat-icon></button>
                    <ng-container *ngIf="currentEntity?.productId != null">
                      <button mat-button class="p-2 button info-button" [disabled]="getIsCaseExpired || disableUpgradeButton" (click)="onOpenUpgradeProduct()"> Upgrade de producto <mat-icon>upgrade</mat-icon></button>
                    </ng-container>
                    <p class="text-danger" *ngIf="getIsCaseExpired">No es posible agregar servicios debido a que el caso se encuentra expirado</p>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-end" *ngIf="hasPendingPayment">
                <div class="mx-1">
                  <button class="btn bg-info text-white p-2 rounded" style="width: fit-content;" disabled><mat-icon>info</mat-icon>Tienes un pago pendiente</button>
                </div>
                <div *ngIf="!showPaymentStatusAlert()">
                  <button class="btn bg-danger text-white p-2 rounded" style="width: fit-content;" (click)="onHandleCancelOrderClick()">Descartar pedido<mat-icon>cancel</mat-icon></button>
                </div>
                
                
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <mat-card class="card-general" style="min-height: 350px;">
        <mat-card-title>Etapas a Fabricar</mat-card-title>
        <mat-card-content class="d-flex flex-column gap-4">
          <div class="text-end" style="overflow-x:auto;">
            <app-client-case-stages [isFinalStatus]="isFinalStatus" [caseId]="caseId" [case]="currentEntity" [availableAligners]="currentEntity?.remainingAligners" [isCaseExpired]="getIsCaseExpired" [currentStageNumber]="currentEntity?.currentCaseStageNumber" (stagesSelected)="onChangeStagesSelected($event)"></app-client-case-stages>
          </div>

          <div class="text-center w-100">
            <mat-card class="card-general">
              <mat-card-content class="d-flex flex-column gap-2 mx-auto text-start">

                <ng-container *ngIf="!hasUnlimitedAligners && alignersResume != undefined">
                  
                  <div class="row">
                    <div class="col-12  fw-semibold">Alineadores requeridos del caso</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{alignersResume.upperAlignersRequiredInCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{alignersResume.lowerAlignersRequiredInCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{alignersResume.totalAlignersRequiredInCase}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="row">
                    <div class="col-12  fw-semibold">Alineadores fabricados al momento</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{alignersResume.fabricatedUpperAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{alignersResume.fabricatedLowerAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{alignersResume.totalFabricatedAligners}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="col-12  fw-semibold">Desglose de fabricación por etapa</div>
                  <div class="row" *ngFor="let e of alignersResume.stageAlignersResume">
                    <div class="col-12  fw-semibold">Etapa {{e.stageNumber}}</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{e.upperAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{e.lowerAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{e.totalAligners}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="row">
                    <div class="col-12  fw-semibold">Alineadores pendientes por fabricar para terminar el caso</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{alignersResume.upperAlignersPendingToBeFabricatedToFinishCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{alignersResume.lowerAlignersPendingToBeFabricatedToFinishCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{alignersResume.totalAlignersPendingToBeFabricatedToFinishCase}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="row">
                    <div class="col-12 "><span class="me-2 fw-semibold">Alineadores comprados para el caso : </span> <strong>{{alignersResume.totalAlignersPurchasedCase}}</strong></div>
                    <div class="col-12 "><span class="me-2 fw-semibold">alineadores sobrantes de producto asignado para fabricación : </span> <strong>{{alignersResume.alignersAvailableToBeFabricated}}</strong></div>
                    <div class="col-12 "><span class="me-2 fw-semibold">Alineadores sobrantes de producto asignado de los requeridos : </span> <strong>{{alignersResume.productAlignersInExcessOfRequiredCaseOnes}}</strong></div>
                  </div>

                </ng-container>
                <ng-container *ngIf="hasUnlimitedAligners && alignersResume != undefined">
                  <div class="row">
                    <div class="col-12 fw-semibold">Alineadores requeridos del caso</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{alignersResume.upperAlignersRequiredInCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{alignersResume.lowerAlignersRequiredInCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{alignersResume.totalAlignersRequiredInCase}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="row">
                    <div class="col-12 fw-semibold">Alineadores fabricados al momento</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{alignersResume.fabricatedUpperAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{alignersResume.fabricatedLowerAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{alignersResume.totalFabricatedAligners}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="col-12  fw-semibold">Desglose de fabricación por etapa</div>
                  <div class="row" *ngFor="let e of alignersResume.stageAlignersResume">
                    <div class="col-12  fw-semibold">Etapa {{e.stageNumber}}</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{e.upperAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{e.lowerAligners}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{e.totalAligners}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="row">
                    <div class="col-12 fw-semibold">Alineadores pendientes por fabricar para terminar el caso</div>
                    <div class="col-3 "><span class="me-2">Superiores: </span> <strong>{{alignersResume.upperAlignersPendingToBeFabricatedToFinishCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Inferiores: </span> <strong>{{alignersResume.lowerAlignersPendingToBeFabricatedToFinishCase}}</strong></div>
                    <div class="col-3 "><span class="me-2">Totales: </span> <strong>{{alignersResume.totalAlignersPendingToBeFabricatedToFinishCase}}</strong></div>
                  </div>
                  <hr class="hr-half">
                  <div class="row">
                    <div class="col-12 "><span class="me-2 fw-semibold">Alineadores comprados para el caso : </span> <strong>Ilimitados</strong></div>
                    <div class="col-12 "><span class="me-2 fw-semibold">alineadores sobrantes de producto asignado para fabricación : </span> <strong>Ilimitados</strong></div>
                    <div class="col-12 "><span class="me-2 fw-semibold">Alineadores sobrantes de producto asignado de los requeridos : </span> <strong>Ilimitados</strong></div>
                  </div>

                </ng-container>
                <button mat-button class="button secondary-button" (click)="confirmManufacturingDialog.show = !confirmManufacturingDialog.show" *ngIf="stagesSelected.length!=0">Mandar a Fabricación <mat-icon>send</mat-icon></button>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-card-content>
      </mat-card>
      
        <!-- Case Log -->
        <div class="col-12">
          <mat-card class="card-general h-100">
            <mat-card-title>Log del Caso</mat-card-title>
            <mat-card-content class="d-flex flex-column gap-2 h-100 p-4" >
              <ng-container *ngIf="currentEntity?.caseHistory && !isLoading; else noRows">
                <div class="row row-status responsive-border-bottom mb-2 mb-sm-0" *ngFor="let item of currentEntity?.caseHistory">
                  <p class="col-12 col-sm-3 rounded" [ngStyle]="{'background-color': item.statusColor, 'color': item.statusColor != 'transparent' ? '#fff' : '#333'}">{{item.statusEcommerceDescription}}</p>
                  <p class="col-12 col-sm-2">{{item.stageNumber ? 'Etapa #' : '' }}<strong>{{item.stageNumber}}</strong></p>
                  <p class="col-12 col-sm-2">{{item.createdDate | dynamic: 'dateTime'}}</p>
                  <p class="col-12 col-sm-5">{{item.commentsEcommerce}}</p>
                </div>
              </ng-container>
              <ng-template #noRows>
                <div class="d-flex flex-column align-items-center justify-content-center gap-4">
                  <app-loading></app-loading>
                  <p>Obteniendo historial del caso...</p>
                </div>
              </ng-template>
            </mat-card-content>
          </mat-card>
        </div>      
    </div>
  </div>
</div>

<app-dialog #caseServicesCatalogDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" height="auto" width="90%">
  <!-- CASE SERVICES -->
  <div *ngIf="currentEntity?.productId && currentCustomer; else noProductSelected">
    <app-client-case-services (hasComplexCaseEvent)="setComplexCase($event)" (canCalculateUpgradeCost)="setDisableUpgradeButton($event)" (productsReadyEvent)="setProductsUpgrade($event)" [currentCase]="currentEntity" [currentCustomer]="currentCustomer" [productId]="currentEntity.productId" ></app-client-case-services>
  </div>


  <!-- SET PRODUCT OPTIONS -->
  <ng-template #noProductSelected>
    <div *ngIf="!showProductCatalog" class="w-100 p-2 p-md-5 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center">No tienes ning&uacute;n producto definido aún, para poder agregar un servicio al caso es necesario que elijas el tipo de caso Aliwell<sup>&#174;</sup> que deseas utilizar.</h2>
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">

      <div class="row gy-3 w-75 mx-auto">
        <div class="col-12 col-lg-6">
          <button mat-button class="button secondary-button w-100" (click)="buyNewProductClicked()">Comprar paquete <mat-icon>shopping_cart</mat-icon> </button>
        </div>
        <div class="col-12 col-lg-6">
          <button mat-button class="button terciary-button w-100" (click)="getPurchasedProducts()">Asignar de mi stock de paquetes <mat-icon>chevron_right</mat-icon> </button>
        </div>
      </div>

    </div>

    <!-- PRODUCT CATALOG -->
    <div *ngIf="showProductCatalog">
      <div class="text-end position-absolute" style="padding-left:10px; top: -40px;">
        <mat-icon (click)="showProductCatalog = !showProductCatalog" style="cursor: pointer; transform: scale(1.5);">chevron_left</mat-icon>
      </div>
      <ng-container *ngIf="isTemplateForProductStore; else purchasedProductsTemplate">
        <app-product-list></app-product-list>
      </ng-container>
      <ng-template #purchasedProductsTemplate>
        <app-purchased-product-list></app-purchased-product-list>
      </ng-template>
    </div>
  </ng-template>
</app-dialog>

<app-dialog #confirmManufacturingSuccessDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [enableConfirmButton]="true" confirmButtonText="Cerrar" confirmButtonClass="button info-button" height="90%" width="90%">
    <div>
      <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
        <h2 class="col text-center">¡Su etapa ha sido enviada a fabricación!</h2>
        <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-mail-sent.svg" alt="Notificación imagen">
      </div>
    </div>
</app-dialog>


<app-dialog #confirmManufacturingDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="orderToManufacture.bind(this)" confirmButtonText="Fabricar" confirmButtonIcon="send" confirmButtonClass="button secondary-button" height="90%" width="90%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center" *ngIf="stagesSelected.length>1; else singularStage">Estas a punto de mandar a fabricar las "Etapas [<span *ngFor="let item of stagesSelected">{{item.stageNumber}},</span>]" y contienen [<span *ngFor="let item of stagesSelected">{{item.alignersQuantity}},</span>] Alineadores respectivamente ¿Desea confirmar?</h2>
      <ng-template #singularStage>
        <h2 class="col text-center">Estas a punto de mandar a fabricar la "Etapa {{stagesSelected[0]?.stageNumber}}" y contiene {{stagesSelected[0]?.alignersQuantity}} Alineadores ¿Desea confirmar?</h2>
      </ng-template>
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
    </div>
  </div>
</app-dialog>

<app-dialog #confirmManufacturingSuccessDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [enableConfirmButton]="true" confirmButtonText="Cerrar" confirmButtonClass="button info-button" height="90%" width="90%">
    <div>
      <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
        <h2 class="col text-center">¡Su etapa ha sido enviada a fabricación!</h2>
        <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-mail-sent.svg" alt="Notificación imagen">
      </div>
    </div>
</app-dialog>

<app-dialog #upgradeProductDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="showDeleteCart.bind(this)" confirmButtonText="Aceptar y pagar" cancelButtonClass="button info-button" confirmButtonClass="button secondary-button" height="60%" width="90%">
  <div class="d-flex justify-content-center">
    <div>
      <p class="display-4">¡Mejora el producto de tu caso!</p>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-3 mb-3">
    <div class="card" style="width: 30rem;">
      <img style="height:15vw; width:100%; object-fit:contain" class="card-img-top" src="{{productUpgradeImage}}" alt="Card image cap">
      <div class="card-body">
        <h5 class="card-title">Upgrade de producto</h5>
        <p class="card-text">Mejora tu paquete actual con los siguientes productos:</p>
        <div>
          <mat-form-field>
            <mat-label>Nuevo paquete</mat-label>
            <mat-select style="min-width:250px" name="upgradeProduct" id="upgradeProduct" [(ngModel)]="upgradeProduct" (selectionChange)="setProductImage()">
              <mat-option *ngFor="let newProduct of products" [value]="newProduct">{{newProduct.name}} con {{newProduct.alignersQuantity == 0 ? 'ilimitados' : newProduct.alignersQuantity}} alineadores, {{newProduct.finalPrice | currency}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</app-dialog>

<app-dialog #confirmDeleteCurrentCart [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="makeChargeUpgrade.bind(this)" confirmButtonText="Aceptar" confirmButtonClass="button danger-button rounded" height="60%" width="90%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center">Para continuar con el proceso de compra, es necesario eliminar los productos del Carrito<strong> ¿Desea continuar?</strong></h2>
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
    </div>
  </div>
</app-dialog>

<app-dialog #confirmCancelOrderDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onCancelOrder.bind(this)" confirmButtonText="Aceptar" confirmButtonClass="button danger-button rounded" height="60%" width="90%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center">¿Estás seguro que deseas cancelar esta compra? El caso permanecerá activo.<strong> ¿Desea continuar?</strong></h2>
    </div>
  </div>
</app-dialog>